import React, { useEffect, useState } from "react";
import MarqueeSlider from "./MarqueeSlider";
// import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
// import "./Slider.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import image from "../Assets/images/image.png";
import image6 from "../Assets/images/image 6.png";
import image7 from "../Assets/images/image 7.png";
import image8 from "../Assets/images/image 8.png";
import FooterBG from "../Assets/images/FooterBG.png";
import mobileDown from "../Assets/images/mobile_download.png";
import gplayBtn from "../Assets/images/googlePlayBtn.png";
import mobileImg from "../Assets/images/mobileImg.png";
import qrApp from "../Assets/images/qrApp.png";

// import Navbar from "../Pages/Navbar"
import CarrierPotentials from "./CarrierPotentials";
import Carrier from "./Carrier";
import Companies from "./Companies";
import JobFairSec from "./JobFairSec";
import Feedback from "./Feedback";
import News from "./News";

import drppl from "../Assets/company_logo/drppl.png";
import GoodFBurgers from "../Assets/company_logo/GoodFBurgers.png";
import tape from "../Assets/company_logo/Glutape.png";
import JSS from "../Assets/company_logo/JSS.png";
import SJM from "../Assets/company_logo/SJM.png";
// import Thar from "../Assets/company_logo/THAR.png";

// import everest from "../Assets/company_logo/everest.png";
// import tata from "../Assets/company_logo/tata.png";

import Glutape from "../Assets/New Logos/Glutape.png";
import debt from "../Assets/New Logos/debt.png";
import GFB from "../Assets/New Logos/GFB.png";
import msipl from "../Assets/New Logos/MSIPL.png";
import OASIS from "../Assets/New Logos/OASIS.png";
import Sara from "../Assets/New Logos/Sara.png";
import sila from "../Assets/New Logos/sila.png";
import Svasti from "../Assets/New Logos/Svasti.png";
import YDCPL from "../Assets/New Logos/YDCPL.png";
import THAR from "../Assets/New Logos/Thar.png";
import Magnum from "../Assets/New Logos/Magnum.png";
import Zepto from "../Assets/New Logos/Zepto.png";

// import mssu from "../Assets/Associated Organisation/MSSU.png";
// import nsdc from "../Assets/Associated Organisation/NSDC.png";
// import Skill from "../Assets/Associated Organisation/Skill.png";
// import Tifac from "../Assets/Associated Organisation/TIFAC.jpg";

import sapio from "../Assets/company_logo/sapio.png";
import black from "../Assets/company_logo/black.png";
import ncs from "../Assets/company_logo/ncs.png";

// import cibs from "../Assets/company_logo/cibs.png";
// import aei from "../Assets/company_logo/aei.jpeg";
// import amp from "../Assets/company_logo/amp.png";
// import ccs from "../Assets/company_logo/ccs.jpeg";
// import destiny from "../Assets/company_logo/destiny.jpeg";

import course_img from "../Assets/Real/course.png";
import job_img from "../Assets/Real/jobs.png";

import Stories from "./Stories";
import AEF from "../Assets/images/AEF.png";
import CarreerSol from "../Assets/images/CarreerSolution.png";
import destinyPlanner from "../Assets/images/destinyPlanner.png";
import ImpM1 from "../Assets/images/ImpM1.png";
import ImpM2 from "../Assets/images/ImpM2.png";
import ImpM3 from "../Assets/images/ImpM3.png";

import BGImg from "../Assets/images/BGImage.png";

import Searchbar from "./Searchbar";
import axios from "axios";
import Navbar from "../Pages/Navbar";
import { Tooltip } from "antd";

//  ----------- Your Dream Job is Here Data --------------
const data2 = [
  {
    image: image,
    job_title: `Psychologist`,
    jobdesc: `Job Details outlines the duties, responsibilities, qualifications, and expectations of a specific job role.`,
  },

  {
    image: image6,
    job_title: `UI / UX Designer`,
    jobdesc: `Job Details outlines the duties, responsibilities, qualifications, and expectations of a specific job role.`,
  },

  {
    image: image7,
    job_title: `Share Market Analyst`,
    jobdesc: `Job Details outlines the duties, responsibilities, qualifications, and expectations of a specific job role.`,
  },

  {
    image: image8,
    job_title: `Public Speaker`,
    jobdesc: `Job Details outlines the duties, responsibilities, qualifications, and expectations of a specific job role.`,
  },
];

//  -------------Enhance Your Skill Data ----------------
const data = [
  {
    img: image,
    name: `Public Speaking`,
    CourseBy: `MindCare Academy`,
    Modules: `10 Modules`,
    Price: `₹7,500`,
  },

  {
    img: image6,
    name: `Stock Market Basics`,
    CourseBy: `MindCare Academy`,
    Modules: `10 Modules`,
    Price: `₹7,500`,
  },

  {
    img: image7,
    name: `Product Design Course`,
    CourseBy: `MindCare Academy`,
    Modules: `10 Modules`,
    Price: `₹7,500`,
  },

  {
    img: image8,
    name: `Psychology Training`,
    CourseBy: `MindCare Academy`,
    Modules: `10 Modules`,
    Price: `₹7,500`,
  },
];

// ------------------Navbar------------------------------

//  ------------------- Important members of Saksham -------------------

const data3 = [
  {
    img: ImpM1,
    designation: `Hon'ble Minister of State (Independent Charge) of the Ministry of Science and Technology Government of India`,
    name: `Dr. Jitendra Singh`,
  },

  {
    img: ImpM2,
    designation: `Secretary, Department of Science & Technology Government of India`,
    name: `Dr. Abhay Karandikar`,
  },

  {
    img: ImpM3,
    designation: `Executive Director, TIFAC`,
    name: `Shri Pradeep Srivastava`,
  },
];
function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    />
  );
}

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 4,
  slidesToScroll: 1,
  prevArrow: (
    <div className="slick-prev">
      <svg
        width="15"
        height="26"
        viewBox="0 0 15 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.67568 13L15 3.03333L12.1622 0L0 13L12.1622 26L15 22.9667L5.67568 13Z"
          fill="#192C56"
        />
      </svg>
    </div>
  ),
  nextArrow: (
    <div className="slick-next">
      <svg
        width="15"
        height="27"
        viewBox="0 0 15 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.32432 13.5L0 3.53333L2.83784 0.5L15 13.5L2.83784 26.5L0 23.4667L9.32432 13.5Z"
          fill="#192C56"
        />
      </svg>
    </div>
  ),
  // nextArrow: <SampleNextArrow />,
  // prevArrow: <SamplePrevArrow />,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

const settings2 = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 1,
  centerMode: false,
  prevArrow: (
    <div className="slick-prev">
      <svg
        width="15"
        height="26"
        viewBox="0 0 15 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.67568 13L15 3.03333L12.1622 0L0 13L12.1622 26L15 22.9667L5.67568 13Z"
          fill="#192C56"
        />
      </svg>
    </div>
  ),
  nextArrow: (
    <div className="slick-next">
      <svg
        width="15"
        height="27"
        viewBox="0 0 15 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.32432 13.5L0 3.53333L2.83784 0.5L15 13.5L2.83784 26.5L0 23.4667L9.32432 13.5Z"
          fill="#192C56"
        />
      </svg>
    </div>
  ),
  // nextArrow: <SampleNextArrow />,
  // prevArrow: <SamplePrevArrow />,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 2,
      },
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
};

const popular = [
  {
    logo: (
      <svg
        width="17"
        height="18"
        viewBox="0 0 17 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.125 16H5.3125V10H11.6875V16H14.875V7L8.5 2.5L2.125 7V16ZM0 18V6L8.5 0L17 6V18H9.5625V12H7.4375V18H0Z"
          fill="#192C56"
        />
      </svg>
    ),
    text: "DRA",
  },
  {
    logo: (
      <svg
        width="19"
        height="18"
        viewBox="0 0 19 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.400391 18V4H4.40039V0H14.4004V8H18.4004V18H10.4004V14H8.40039V18H0.400391ZM2.40039 16H4.40039V14H2.40039V16ZM2.40039 12H4.40039V10H2.40039V12ZM2.40039 8H4.40039V6H2.40039V8ZM6.40039 12H8.40039V10H6.40039V12ZM6.40039 8H8.40039V6H6.40039V8ZM6.40039 4H8.40039V2H6.40039V4ZM10.4004 12H12.4004V10H10.4004V12ZM10.4004 8H12.4004V6H10.4004V8ZM10.4004 4H12.4004V2H10.4004V4ZM14.4004 16H16.4004V14H14.4004V16ZM14.4004 12H16.4004V10H14.4004V12Z"
          fill="#F26622"
        />
      </svg>
    ),
    text: "Debt Collection Agent",
  },
  {
    logo: (
      <svg
        width="17"
        height="18"
        viewBox="0 0 17 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2.125 16H5.3125V10H11.6875V16H14.875V7L8.5 2.5L2.125 7V16ZM0 18V6L8.5 0L17 6V18H9.5625V12H7.4375V18H0Z"
          fill="#192C56"
        />
      </svg>
    ),
    text: "Sales Executive",
  },
  {
    logo: (
      <svg
        width="23"
        height="16"
        viewBox="0 0 23 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.199219 16V13.2C0.199219 12.6333 0.345052 12.1125 0.636719 11.6375C0.928385 11.1625 1.31589 10.8 1.79922 10.55C2.83255 10.0333 3.88255 9.64583 4.94922 9.3875C6.01589 9.12917 7.09922 9 8.19922 9C9.29922 9 10.3826 9.12917 11.4492 9.3875C12.5159 9.64583 13.5659 10.0333 14.5992 10.55C15.0826 10.8 15.4701 11.1625 15.7617 11.6375C16.0534 12.1125 16.1992 12.6333 16.1992 13.2V16H0.199219ZM18.1992 16V13C18.1992 12.2667 17.9951 11.5625 17.5867 10.8875C17.1784 10.2125 16.5992 9.63333 15.8492 9.15C16.6992 9.25 17.4992 9.42083 18.2492 9.6625C18.9992 9.90417 19.6992 10.2 20.3492 10.55C20.9492 10.8833 21.4076 11.2542 21.7242 11.6625C22.0409 12.0708 22.1992 12.5167 22.1992 13V16H18.1992ZM8.19922 8C7.09922 8 6.15755 7.60833 5.37422 6.825C4.59089 6.04167 4.19922 5.1 4.19922 4C4.19922 2.9 4.59089 1.95833 5.37422 1.175C6.15755 0.391667 7.09922 0 8.19922 0C9.29922 0 10.2409 0.391667 11.0242 1.175C11.8076 1.95833 12.1992 2.9 12.1992 4C12.1992 5.1 11.8076 6.04167 11.0242 6.825C10.2409 7.60833 9.29922 8 8.19922 8ZM18.1992 4C18.1992 5.1 17.8076 6.04167 17.0242 6.825C16.2409 7.60833 15.2992 8 14.1992 8C14.0159 8 13.7826 7.97917 13.4992 7.9375C13.2159 7.89583 12.9826 7.85 12.7992 7.8C13.2492 7.26667 13.5951 6.675 13.8367 6.025C14.0784 5.375 14.1992 4.7 14.1992 4C14.1992 3.3 14.0784 2.625 13.8367 1.975C13.5951 1.325 13.2492 0.733333 12.7992 0.2C13.0326 0.116667 13.2659 0.0625 13.4992 0.0375C13.7326 0.0125 13.9659 0 14.1992 0C15.2992 0 16.2409 0.391667 17.0242 1.175C17.8076 1.95833 18.1992 2.9 18.1992 4ZM2.19922 14H14.1992V13.2C14.1992 13.0167 14.1534 12.85 14.0617 12.7C13.9701 12.55 13.8492 12.4333 13.6992 12.35C12.7992 11.9 11.8909 11.5625 10.9742 11.3375C10.0576 11.1125 9.13255 11 8.19922 11C7.26589 11 6.34089 11.1125 5.42422 11.3375C4.50755 11.5625 3.59922 11.9 2.69922 12.35C2.54922 12.4333 2.42839 12.55 2.33672 12.7C2.24505 12.85 2.19922 13.0167 2.19922 13.2V14ZM8.19922 6C8.74922 6 9.22005 5.80417 9.61172 5.4125C10.0034 5.02083 10.1992 4.55 10.1992 4C10.1992 3.45 10.0034 2.97917 9.61172 2.5875C9.22005 2.19583 8.74922 2 8.19922 2C7.64922 2 7.17839 2.19583 6.78672 2.5875C6.39505 2.97917 6.19922 3.45 6.19922 4C6.19922 4.55 6.39505 5.02083 6.78672 5.4125C7.17839 5.80417 7.64922 6 8.19922 6Z"
          fill="#F26622"
        />
      </svg>
    ),
    text: "Field Sales Executive",
  },
  {
    logo: (
      <svg
        width="23"
        height="18"
        viewBox="0 0 23 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.601562 18V15.2C0.601562 14.65 0.743229 14.1333 1.02656 13.65C1.3099 13.1667 1.70156 12.8 2.20156 12.55C3.05156 12.1167 4.0099 11.75 5.07656 11.45C6.14323 11.15 7.31823 11 8.60156 11C9.8849 11 11.0599 11.15 12.1266 11.45C13.1932 11.75 14.1516 12.1167 15.0016 12.55C15.5016 12.8 15.8932 13.1667 16.1766 13.65C16.4599 14.1333 16.6016 14.65 16.6016 15.2V18H0.601562ZM2.60156 16H14.6016V15.2C14.6016 15.0167 14.5557 14.85 14.4641 14.7C14.3724 14.55 14.2516 14.4333 14.1016 14.35C13.5016 14.05 12.7307 13.75 11.7891 13.45C10.8474 13.15 9.7849 13 8.60156 13C7.41823 13 6.35573 13.15 5.41406 13.45C4.4724 13.75 3.70156 14.05 3.10156 14.35C2.95156 14.4333 2.83073 14.55 2.73906 14.7C2.6474 14.85 2.60156 15.0167 2.60156 15.2V16ZM8.60156 10C7.50156 10 6.5599 9.60833 5.77656 8.825C4.99323 8.04167 4.60156 7.1 4.60156 6H4.35156C4.20156 6 4.08073 5.95417 3.98906 5.8625C3.8974 5.77083 3.85156 5.65 3.85156 5.5C3.85156 5.35 3.8974 5.22917 3.98906 5.1375C4.08073 5.04583 4.20156 5 4.35156 5H4.60156C4.60156 4.25 4.7849 3.575 5.15156 2.975C5.51823 2.375 6.00156 1.9 6.60156 1.55V2.5C6.60156 2.65 6.6474 2.77083 6.73906 2.8625C6.83073 2.95417 6.95156 3 7.10156 3C7.25156 3 7.3724 2.95417 7.46406 2.8625C7.55573 2.77083 7.60156 2.65 7.60156 2.5V1.15C7.75156 1.1 7.9099 1.0625 8.07656 1.0375C8.24323 1.0125 8.41823 1 8.60156 1C8.7849 1 8.9599 1.0125 9.12656 1.0375C9.29323 1.0625 9.45156 1.1 9.60156 1.15V2.5C9.60156 2.65 9.6474 2.77083 9.73906 2.8625C9.83073 2.95417 9.95156 3 10.1016 3C10.2516 3 10.3724 2.95417 10.4641 2.8625C10.5557 2.77083 10.6016 2.65 10.6016 2.5V1.55C11.2016 1.9 11.6849 2.375 12.0516 2.975C12.4182 3.575 12.6016 4.25 12.6016 5H12.8516C13.0016 5 13.1224 5.04583 13.2141 5.1375C13.3057 5.22917 13.3516 5.35 13.3516 5.5C13.3516 5.65 13.3057 5.77083 13.2141 5.8625C13.1224 5.95417 13.0016 6 12.8516 6H12.6016C12.6016 7.1 12.2099 8.04167 11.4266 8.825C10.6432 9.60833 9.70156 10 8.60156 10ZM8.60156 8C9.15156 8 9.6224 7.80417 10.0141 7.4125C10.4057 7.02083 10.6016 6.55 10.6016 6H6.60156C6.60156 6.55 6.7974 7.02083 7.18906 7.4125C7.58073 7.80417 8.05156 8 8.60156 8ZM16.1016 12L15.9516 11.25C15.8516 11.2167 15.7557 11.1792 15.6641 11.1375C15.5724 11.0958 15.4849 11.0333 15.4016 10.95L14.7016 11.2L14.2016 10.3L14.7516 9.8V9.2L14.2016 8.7L14.7016 7.8L15.4016 8.05C15.4682 7.98333 15.5516 7.925 15.6516 7.875C15.7516 7.825 15.8516 7.78333 15.9516 7.75L16.1016 7H17.1016L17.2516 7.75C17.3516 7.78333 17.4516 7.825 17.5516 7.875C17.6516 7.925 17.7349 7.98333 17.8016 8.05L18.5016 7.8L19.0016 8.7L18.4516 9.2V9.8L19.0016 10.3L18.5016 11.2L17.8016 10.95C17.7182 11.0333 17.6307 11.0958 17.5391 11.1375C17.4474 11.1792 17.3516 11.2167 17.2516 11.25L17.1016 12H16.1016ZM16.6016 10.25C16.8016 10.25 16.9766 10.175 17.1266 10.025C17.2766 9.875 17.3516 9.7 17.3516 9.5C17.3516 9.3 17.2766 9.125 17.1266 8.975C16.9766 8.825 16.8016 8.75 16.6016 8.75C16.4016 8.75 16.2266 8.825 16.0766 8.975C15.9266 9.125 15.8516 9.3 15.8516 9.5C15.8516 9.7 15.9266 9.875 16.0766 10.025C16.2266 10.175 16.4016 10.25 16.6016 10.25ZM18.4016 7L18.2016 5.95C18.0516 5.9 17.9141 5.8375 17.7891 5.7625C17.6641 5.6875 17.5516 5.6 17.4516 5.5L16.4016 5.85L15.7016 4.65L16.5516 3.9C16.5182 3.81667 16.5016 3.75 16.5016 3.7V3.3C16.5016 3.25 16.5182 3.18333 16.5516 3.1L15.7016 2.35L16.4016 1.15L17.4516 1.5C17.5516 1.4 17.6641 1.3125 17.7891 1.2375C17.9141 1.1625 18.0516 1.1 18.2016 1.05L18.4016 0H19.8016L20.0016 1.05C20.1516 1.1 20.2891 1.1625 20.4141 1.2375C20.5391 1.3125 20.6516 1.4 20.7516 1.5L21.8016 1.15L22.5016 2.35L21.6516 3.1C21.6849 3.18333 21.7016 3.25 21.7016 3.3V3.7C21.7016 3.75 21.6849 3.81667 21.6516 3.9L22.5016 4.65L21.8016 5.85L20.7516 5.5C20.6516 5.6 20.5391 5.6875 20.4141 5.7625C20.2891 5.8375 20.1516 5.9 20.0016 5.95L19.8016 7H18.4016ZM19.1016 4.75C19.4516 4.75 19.7474 4.62917 19.9891 4.3875C20.2307 4.14583 20.3516 3.85 20.3516 3.5C20.3516 3.15 20.2307 2.85417 19.9891 2.6125C19.7474 2.37083 19.4516 2.25 19.1016 2.25C18.7516 2.25 18.4557 2.37083 18.2141 2.6125C17.9724 2.85417 17.8516 3.15 17.8516 3.5C17.8516 3.85 17.9724 4.14583 18.2141 4.3875C18.4557 4.62917 18.7516 4.75 19.1016 4.75Z"
          fill="#192C56"
        />
      </svg>
    ),
    text: "Drivers",
  },
  {
    logo: (
      <svg
        width="21"
        height="18"
        viewBox="0 0 21 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.5 18V16H20.5V18H0.5ZM4.5 14C3.95 14 3.47917 13.8042 3.0875 13.4125C2.69583 13.0208 2.5 12.55 2.5 12V5C2.5 4.45 2.69583 3.97917 3.0875 3.5875C3.47917 3.19583 3.95 3 4.5 3H7.5C7.5 2.16667 7.79167 1.45833 8.375 0.875C8.95833 0.291667 9.66667 0 10.5 0C11.3333 0 12.0417 0.291667 12.625 0.875C13.2083 1.45833 13.5 2.16667 13.5 3H16.5C17.05 3 17.5208 3.19583 17.9125 3.5875C18.3042 3.97917 18.5 4.45 18.5 5V12C18.5 12.55 18.3042 13.0208 17.9125 13.4125C17.5208 13.8042 17.05 14 16.5 14H4.5ZM15.5 12H16.5V5H15.5V12ZM9 3H12C12 2.56667 11.8583 2.20833 11.575 1.925C11.2917 1.64167 10.9333 1.5 10.5 1.5C10.0667 1.5 9.70833 1.64167 9.425 1.925C9.14167 2.20833 9 2.56667 9 3ZM5.5 12V5H4.5V12H5.5ZM7 5V12H14V5H7Z"
          fill="#F26622"
        />
      </svg>
    ),
    text: "Telecallers",
  },
  {
    logo: (
      <svg
        width="21"
        height="18"
        viewBox="0 0 21 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.9473 8.05V16C19.9473 16.55 19.7515 17.0208 19.3598 17.4125C18.9682 17.8042 18.4973 18 17.9473 18H3.94733C3.39733 18 2.9265 17.8042 2.53483 17.4125C2.14316 17.0208 1.94733 16.55 1.94733 16V8.05C1.564 7.7 1.26816 7.25 1.05983 6.7C0.851496 6.15 0.847329 5.55 1.04733 4.9L2.09733 1.5C2.23066 1.06667 2.46816 0.708333 2.80983 0.425C3.1515 0.141667 3.54733 0 3.99733 0H17.8973C18.3473 0 18.739 0.1375 19.0723 0.4125C19.4057 0.6875 19.6473 1.05 19.7973 1.5L20.8473 4.9C21.0473 5.55 21.0432 6.14167 20.8348 6.675C20.6265 7.20833 20.3307 7.66667 19.9473 8.05ZM13.1473 7C13.5973 7 13.939 6.84583 14.1723 6.5375C14.4057 6.22917 14.4973 5.88333 14.4473 5.5L13.8973 2H11.9473V5.7C11.9473 6.05 12.064 6.35417 12.2973 6.6125C12.5307 6.87083 12.814 7 13.1473 7ZM8.64733 7C9.03066 7 9.34316 6.87083 9.58483 6.6125C9.8265 6.35417 9.94733 6.05 9.94733 5.7V2H7.99733L7.44733 5.5C7.38066 5.9 7.46816 6.25 7.70983 6.55C7.9515 6.85 8.264 7 8.64733 7ZM4.19733 7C4.49733 7 4.75983 6.89167 4.98483 6.675C5.20983 6.45833 5.34733 6.18333 5.39733 5.85L5.94733 2H3.99733L2.99733 5.35C2.89733 5.68333 2.9515 6.04167 3.15983 6.425C3.36816 6.80833 3.714 7 4.19733 7ZM17.6973 7C18.1807 7 18.5307 6.80833 18.7473 6.425C18.964 6.04167 19.014 5.68333 18.8973 5.35L17.8473 2H15.9473L16.4973 5.85C16.5473 6.18333 16.6848 6.45833 16.9098 6.675C17.1348 6.89167 17.3973 7 17.6973 7ZM3.94733 16H17.9473V8.95C17.864 8.98333 17.8098 9 17.7848 9H17.6973C17.2473 9 16.8515 8.925 16.5098 8.775C16.1682 8.625 15.8307 8.38333 15.4973 8.05C15.1973 8.35 14.8557 8.58333 14.4723 8.75C14.089 8.91667 13.6807 9 13.2473 9C12.7973 9 12.3765 8.91667 11.9848 8.75C11.5932 8.58333 11.2473 8.35 10.9473 8.05C10.664 8.35 10.3348 8.58333 9.95983 8.75C9.58483 8.91667 9.18066 9 8.74733 9C8.264 9 7.8265 8.91667 7.43483 8.75C7.04316 8.58333 6.69733 8.35 6.39733 8.05C6.04733 8.4 5.7015 8.64583 5.35983 8.7875C5.01816 8.92917 4.63066 9 4.19733 9H4.08483C4.04316 9 3.99733 8.98333 3.94733 8.95V16Z"
          fill="#192C56"
        />
      </svg>
    ),
    text: "Credit Manager",
  },
  {
    logo: (
      <svg
        width="19"
        height="18"
        viewBox="0 0 19 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.300781 18V16L2.30078 14V18H0.300781ZM4.30078 18V12L6.30078 10V18H4.30078ZM8.30078 18V10L10.3008 12.025V18H8.30078ZM12.3008 18V12.025L14.3008 10.025V18H12.3008ZM16.3008 18V8L18.3008 6V18H16.3008ZM0.300781 12.825V10L7.30078 3L11.3008 7L18.3008 0V2.825L11.3008 9.825L7.30078 5.825L0.300781 12.825Z"
          fill="#F26622"
        />
      </svg>
    ),
    text: "MIS Executive",
  },
  {
    logo: (
      <svg
        width="21"
        height="12"
        viewBox="0 0 21 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M6.69922 12L0.699219 6L6.69922 0L8.12422 1.425L3.52422 6.025L8.09922 10.6L6.69922 12ZM14.6992 12L13.2742 10.575L17.8742 5.975L13.2992 1.4L14.6992 0L20.6992 6L14.6992 12Z"
          fill="#192C56"
        />
      </svg>
    ),
    text: "International Caller",
  },
  {
    logo: (
      <svg
        width="23"
        height="16"
        viewBox="0 0 23 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.5766 11.825L19.9516 3.45L18.6516 2.15L10.2766 10.525L11.5766 11.825ZM5.05156 14C3.3849 13.9167 2.14323 13.5667 1.32656 12.95C0.509896 12.3333 0.101562 11.4417 0.101562 10.275C0.101562 9.19167 0.547396 8.3125 1.43906 7.6375C2.33073 6.9625 3.56823 6.55833 5.15156 6.425C5.80156 6.375 6.28906 6.27083 6.61406 6.1125C6.93906 5.95417 7.10156 5.73333 7.10156 5.45C7.10156 5.01667 6.85573 4.69167 6.36406 4.475C5.8724 4.25833 5.0599 4.1 3.92656 4L4.10156 2C5.81823 2.13333 7.08073 2.47917 7.88906 3.0375C8.6974 3.59583 9.10156 4.4 9.10156 5.45C9.10156 6.33333 8.78073 7.025 8.13906 7.525C7.4974 8.025 6.55156 8.325 5.30156 8.425C4.2349 8.50833 3.4349 8.70417 2.90156 9.0125C2.36823 9.32083 2.10156 9.74167 2.10156 10.275C2.10156 10.8583 2.3349 11.2792 2.80156 11.5375C3.26823 11.7958 4.05156 11.95 5.15156 12L5.05156 14ZM12.0516 14.175L7.92656 10.05L17.4766 0.5C17.8099 0.166667 18.2057 0 18.6641 0C19.1224 0 19.5182 0.166667 19.8516 0.5L21.6016 2.25C21.9349 2.58333 22.1016 2.97917 22.1016 3.4375C22.1016 3.89583 21.9349 4.29167 21.6016 4.625L12.0516 14.175ZM8.07656 15C7.79323 15.0667 7.54323 14.9917 7.32656 14.775C7.1099 14.5583 7.0349 14.3083 7.10156 14.025L7.92656 10.05L12.0516 14.175L8.07656 15Z"
          fill="#F26622"
        />
      </svg>
    ),
    text: "Accountant",
  },
];
const Home = () => {
  const [jobData, setJobData] = useState([]);
  const [courses, setCourses] = useState([]);
  const [marData, setMarData] = useState([
    { logo: Glutape },
    { logo: GFB },
    { logo: debt },
    { logo: msipl },
    { logo: Magnum },
    { logo: sila },
    { logo: Svasti },
    { logo: YDCPL },
    { logo: THAR },
    { logo: Zepto },
    { logo: OASIS },
    { logo: Sara },
  ]);

  const [companyLogo, setCompanyLogo] = useState([
    { logo: SJM },
    { logo: THAR },
    { logo: GoodFBurgers },
    { logo: tape },
    { logo: drppl },
    { logo: JSS },
  ]);

  const references = [
    { logo: sapio },
    { logo: black },
    { logo: ncs },
    { logo: global },
    { logo: sapio },
    { logo: black },
    { logo: ncs },
    { logo: global },
  ];

  const esrs = [{ logo: AEF }, { logo: CarreerSol }, { logo: destinyPlanner }];
  const [KPIs, setKPIs] = useState([
    { count: "362,345", name: "Number of Job Seekers Registered​" },
    { count: "150K", name: "Number of Job Providers Registered" },
    { count: "4,488", name: "Number of Job Seekers Placed" },
  ]);

  const fetchComps = async () => {
    await axios
      .get(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/form/saksham-kpi`)
      .then((res) => {
        setKPIs([
          {
            count: res.data.js_registered,
            name: "Number of Job Seekers Registered​",
          },
          {
            count: res.data.jp_registered,
            name: "Number of Job Providers Registered",
          },
          { count: res.data.js_placed, name: "Number of Job Seekers Placed" },
        ]);
      })
      .catch((err) => console.log(err));
  };

  function stripHtmlTags(html) {
    return html.replace(/<\/?[^>]+(>|$)/g, "");
  }

  const fetchJobs = async () => {
    await axios
      .get(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/form/saksham-jobs`)
      .then((res) => {
        setJobData(res.data.data);
      })
      .catch((err) => console.log(err));
  };
  const fetchCourses = async () => {
    await axios
      .get(`${process.env.REACT_APP_BACKEND_GENERIC_URL}/form/saksham-courses`)
      .then((res) => {
        setCourses(res.data.data.filter((el, id) => el.course_title !== ""));
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    fetchJobs();
    fetchCourses();
    fetchComps();
  }, []);

  return (
    <>
      {/*...................Important People......................... */}
      {/* <div className="w-full px-10 py-4 my-4 md:my-8 flex flex-col md:flex-col lg:flex-row items-center justify-center gap-4 rounded-[20px] ">
        {data3.map((d) => (
          <div
            key={d.id}
            style={{ backgroundImage: `url(${BGImg})` }}
            className="flex flex-col sm:flex-row items-start  gap-4 flex-1 w-full h-auto px-2 py-8 sm:py-5 bg-cover bg-center overflow-hidden rounded-[20px]"
          > 
          <div className="p-2 flex  items-start justify-start "> 
            <div className="flex-shrink-0 h-[112px] w-[112px] p-1 items-center">
              <img
                src={d.img}
                alt={d.name}
                className="object-cover h-full w-full"
              />
            </div>
            
            <div className="flex-1 text-center pt-2 sm:text-start flex flex-col justify-start">
            <h2 className="text-[16px] leading-[3.75px] font-semibold">
                {d.name}
              </h2>
              <p className="text-[16px] leading-[18.75px] font-normal mt-2">
                {d.designation}
              </p>
              
            </div>
            </div>
          </div>
        ))}
      </div> */}

      <div className="w-full px-10 py-4 my-4 md:my-8 grid grid-cols-1 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-3 gap-2">
        {data3.map((d) => (
          <div
            key={d.id}
            style={{ backgroundImage: `url(${BGImg})` }}
            className="flex flex-col sm:flex-row md:flex-row items-center sm:items-start lg:items-start  md:items-start gap-4 w-full h-auto px-3 pr-3 py-8 sm:py-5 bg-cover bg-center overflow-hidden rounded-[20px]"
          >
            <div className="p-1 flex items-center justify-center w-full sm:w-auto md:w-auto lg:w-auto">
              <div className="flex-shrink-0 h-[112px] w-[112px] p-1 sm:ml-3 md:ml-4 lg:ml-8 ml-1 xl:ml-2 ">
                <img
                  src={d.img}
                  alt={d.name}
                  className="object-cover h-full w-full rounded-[20px] "
                />
              </div>
            </div>

            <div className="flex-1 text-center sm:text-center md:text-start lg-text-start pt-2 pr-4 below-sm:pr-1 flex flex-col justify-center">
              <h2 className="text-[16px] below-sm:text-[14px] below-sm:text-center leading-[18.75px] font-semibold ">
                {d.name}
              </h2>
              <p className="text-[16px] below-sm:text-[14px] leading-[18.75px] font-normal mt-2">
                {d.designation}
              </p>
            </div>
          </div>
        ))}
      </div>

      {/* ...............Unlock Your Career Potential................ */}
      <div>
        <CarrierPotentials />
      </div>

      {/* ...............Popular Categories................ */}

      {/* <div className="px-10  my-9  w-full">
        <p className="font-bold text-[40px] mb-10">Popular Categories</p>
        <div className="relative grid grid-cols-1 sm:grid-cols-3 md:grid-cols-3 lg:grid-cols-5 gap-5">
          {popular.map((el, index) => (
            <div
              key={index}
              className="flex items-center bg-white gap-4 px-3 py-2 rounded border shadow-md max-w-full"
            >
              <div
                className={`${
                  index % 2 === 0 ? "bg-[#AAC9F8]" : "bg-[#FFB27D]"
                } rounded-full h-[33px] w-[33px] flex items-center justify-center`}
              >
                {el.logo}
              </div>
              <div className="flex-1 flex items-center">
                <p className="text-[16px] font-semibold mb-0">{el.text}</p>
              </div>
              <div className="text-xl font-bold flex items-center ml-auto">
                <svg
                  width="8"
                  height="13"
                  viewBox="0 0 8 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M4.6 6.5L0 1.9L1.4 0.5L7.4 6.5L1.4 12.5L0 11.1L4.6 6.5Z"
                    fill="#192C56"
                  />
                </svg> 
              </div> this part is inner comment
            </div>
          ))}
        </div>
      </div> */}

      {/* --------------Your Dream Job is Here---------------- */}
      <div className="w-full h-536 gap-36 ">
        <div className=" mt-14 font-bold text-[40px] below-sm:text-[20px] leading-60 text-center">
          Your Dream Job is Here
        </div>
        <div className="">
          <div className="w-full min-h-373  flex items-center justify-center">
            <div className=" w-[95%] min-h-373 pt-11 pl-14 pr-14">
              <Slider {...settings}>
                {jobData.map((d) => (
                  <div className="relative max-w-sm min-h-[270px] bg-white border border-gray-200 rounded-lg shadow grid gap-8">
                    <div className="flex flex-col justify-between p-4 h-auto">
                      {/* <div className=" flex justify-center w-full ">
                        <img
                          src={d.org_logo ? d.org_logo : job_img}
                          alt=""
                          className="w-20 h-20 rounded-t-lg object-cover"
                        />
                      </div> */}

                      <div className="h-full flex flex-col gap-2 justify-around items-center">
                        <p className="text-2xl  below-sm:text-[17px] font-bold tracking-tight text-black-800 mb-0">
                          {d.designation}
                        </p>
                        <p className="font-semibold below-sm:text-[14px] text-base mb-0">
                          {d.org_name ? d.org_name : "-"}
                        </p>
                        <p className="font-normal below-sm:text-[14px] text-black-700 mb-0">
                          {d.district || d.state
                            ? d.district + ", " + d.state
                            : "-"}
                        </p>

                        {/* <div className="font-normal text-black-700 mb-0">
                          {d.jobdesc ? (
                            stripHtmlTags(d?.jobdesc)?.length > 50 ? (
                              <Tooltip title={stripHtmlTags(d.jobdesc)}>
                                <p className="my-2 font-normal text-black-700 mb-0">
                                  {stripHtmlTags(d.jobdesc).substring(0, 50) +
                                    "..."}
                                </p>
                              </Tooltip>
                            ) : (
                              <p className="my-2 font-normal text-black-700 mb-0">
                                {stripHtmlTags(d.jobdesc)}
                              </p>
                            )
                          ) : (
                            "NA"
                          )}
                        </div> */}
                      </div>

                      <div className="absolute left-1/2 transform -translate-x-1/2 bottom-4">
                        <a href={d.link} target="_blank" rel="noreferrer">
                          <button className="w-[177px] h-[51px] below-sm:w-[140px] below-sm:h-[45px] sm:w-[140px] sm:h-[45px] justify-center text-white p-[16px_8px] gap-[10px] rounded-[6px] bg-[#192C56]">
                            Know More
                          </button>
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
        <div className="pt-10">
          {/* <button className="w-[198px] h-[51px] px-[48px] py-[16px] gap-[10px] rounded-[6px] bg-[#F26622]">
            View All Slides
          </button> */}
        </div>
      </div>

      {/* Mobile download section */}
      <div
        className="w-full shadow p-0 pb-0 relative max-h-[600px] hidden md:block"
        style={{
          backgroundImage: `url(${FooterBG})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        {/* <div className="flex justify-center items-center w-[80%]"> */}
        <div className="grid grid-cols-1 md:grid-cols-2 p-20">
          <div className="flex justify-between items-center gap-10 mt-10 ml-20">
            <div>
              <img src={mobileImg} style={{ height: "90%" }} />
            </div>
            <div>
              <p className="text-left text-[24px] below-sm:text-[18px] leading-[24px] font-bold text-[#FFFFFF]">
                Power Up Your Job Search!
              </p>
              <div className="mt-5">
                <p className="text-left text-[16px] below-sm:text-[14px] leading-[22px] font-normal text-[#FFFFFF]">
                  Get instant notifications, personalised job alerts, and access
                  to skill development programs—all on the go with the{" "}
                  <span className="font-bold">Saksham by TIFAC app.</span>
                </p>
              </div>

              <div className="mt-100">
                <p className="text-left text-[18px] below-sm:text-[17px] leading-[20px] font-bold text-[#FFFFFF]">
                  Download now for the best experience!
                </p>
                <a
                  href="https://play.google.com/store/apps/details?id=com.saksham.saksham&pli=1"
                  target="_blank"
                >
                  <img src={gplayBtn} width="40%" height="53px" />
                </a>
              </div>
            </div>
          </div>
          <div className="flex flex-col items-center mt-12 ml-24">
            <h5 className="text-[18px] below-sm:text-[17px] text-[#FFFFFF] font-bold mb-3">
              Download the Saksham app
            </h5>
            <div className="w-[128px] h-[128px] bg-white mt-5 rounded ">
              <img src={qrApp} />
            </div>
          </div>
        </div>
        {/* </div> */}
      </div>

      <div
        className="w-full shadow p-5 pb-4 relative block md:hidden"
        style={{
          backgroundImage: `url(${FooterBG})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-3"> */}
        <div className="w-full max-w-screen-xl mx-auto pt-0">
          <p className="text-left text-[24px] leading-[24px] font-bold text-[#FFFFFF]">
            Power Up Your Job Search!
          </p>
          <div className="mt-5">
            <p className="text-left text-[16px] leading-[22px] font-normal text-[#FFFFFF]">
              Get instant notifications, personalised job alerts, and access to
              skill development programs—all on the go with the{" "}
              <span className="font-bold">Saksham by TIFAC app.</span>
            </p>
          </div>

          <div
            className="mt-100"
            // style={{
            //   backgroundImage: `url(${gplayBtn})`,
            //   backgroundSize: "cover",
            //   backgroundPosition: "center",
            //   backgroundRepeat: "no-repeat",
            // }}
          >
            <p className="text-left text-[18px] leading-[20px] font-bold text-[#FFFFFF]">
              Download now for the best experience!
            </p>
            <a
              href="https://play.google.com/store/apps/details?id=com.saksham.saksham&pli=1"
              target="_blank"
            >
              <img src={gplayBtn} width="50%" height="53px" />
            </a>
          </div>
        </div>
        {/* </div> */}
      </div>

      {/* ...............KPIs and Companies................. */}
      <div className="bg-[#FFFFFF] max-w-full flex flex-col gap-4 my-8 pb-10">
        {/* my-8 py-8 bg-[192C56] */}
        <div className="flex justify-around items-center flex-col sm:flex-row">
          {/* {KPIs.map((el, id) => {
            return (
              <div key={id}>
                <div className="grid gap-4">
                  <p className="text-white text-4xl font-bold mb-0">
                    {el.count}+
                  </p>
                  <p className="text-white text-m font-medium">{el.name}</p>
                </div>
              </div>
            );
          })} */}
        </div>
        <div className="pt-6">
          <p className="text-black text-[28px] below-sm:text-[15px] font-semibold mb-0">
            Our Satisfied Clients
          </p>
        </div>
        <div className="mt-4">
          <MarqueeSlider data={marData} w={"200px"} h={"200px"} />
        </div>

        <div className="pt-12">
          <p className="text-black text-[28px] below-sm:text-[15px] font-semibold mb-0">
            Associate Organisations
          </p>
        </div>
        <div className="mt-4">
          <MarqueeSlider
            data={companyLogo}
            w={"200px"}
            h={"200px"}
            width={"80%"}
          />
        </div>
      </div>

      {/* --------------Enhance Your Skills---------------- */}
      <div className="my-8 w-full h-536 gap-36">
        <div className="mt-12 font-bold text-[40px] below-sm:text-[20px] leading-60 text-center">
          Enhance Your Skills
        </div>
        <div className="">
          <div className="w-1410 overflow-auto">
            <div className=" w-1252 pt-10 pl-14 pr-14">
              <Slider {...settings}>
                {courses.map((d) => (
                  <div className=" max-w-sm bg-white border border-gray-200 rounded-lg shadow gap-3 below-sm:h-[200px] sm:h-[205px] md:h-[250px] xl:h-[200px]">
                    <div className="p-4">
                      {/* <div className=" flex justify-center w-full ">
                        <img
                          src={d.course_img ? d.course_img : course_img}
                          alt=""
                          className="w-20 h-20 rounded-t-lg object-cover"
                        />
                      </div> */}

                      <div className="">
                        <h5 className="mb-2 text-2xl below-sm:text-[16px] text-black-800 font-bold tracking-tight text-gray-900">
                          {d.course_title}
                        </h5>
                        <p className="mb-1.5 font-semibold below-sm:text-[15px] text-black-700">
                          {d.org_name ? d.org_name : "-"}
                        </p>
                        <p className="mb-1.5 font-normal below-sm:text-[14px] text-black-700">
                          {d?.district + ", " + d?.state}
                        </p>
                        <p className="mb-1.5 font-normal below-sm:text-[14px] text-black-700">
                          Mode : {d.mode_of_course}
                        </p>
                        {/* <p className="mb-3 font-normal text-black-700">
                          Price : {d.fees}
                        </p> */}
                        {/* <button className="w-[177px] h-[51px] mb-3 text-white p-[16px_8px] gap-[10px] rounded-[6px]  bg-[#192C56]">
                          Know More
                        </button> */}
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          </div>
        </div>
        <div className="pt-8">
          {/* <button className="w-[198px] h-[51px] px-[48px] py-[16px] gap-[10px] rounded-[6px] bg-[#F26622]">
            View All Slides
          </button> */}
        </div>
      </div>

      {/* ............Assess Your Job Readiness............. */}
      <Carrier />

      {/*.................Find Your Ideal Role at Top Companies............ */}
      {/* <Companies /> */}

      {/* .....Job Fairs & Events.............. */}
      <JobFairSec />

      {/* .........References............ */}
      {/* <div className="my-2">
        <p className="font-bold text-[40px] my-4">References</p>
        <div className="w-full max-h-[473px] pt-10 px-14">
          <Slider {...settings2}>
            {references.map((d, index) => (
              <div
                key={index}
                className="flex items-center justify-center mx-2" // Center the container and add margin
                style={{ width: "calc(33.333% - 16px)", height: "143px" }} // Set fixed width and height
              >
                <img src={d.logo} alt="Logo" />
              </div>
            ))}
          </Slider>
        </div>
      </div> */}

      {/* ...........Empanelled Saksham Rojgar Sathis............ */}
      <div className=" my-11">
        <p className="font-bold text-[40px] below-sm:text-[20px]">
          Empanelled Saksham Rojgar Sathis
        </p>
        <div className="w-full px-8 below-sm:px-10">
          <p className="font-roboto text-[16px] below-sm:text-[14px] font-normal leading-[40px] xl:text-center text-justify">
            Saksham Rojgar Sathi is an initiative that is bringing together
            placement service providers to help connect job seekers with the
            right opportunities. With access to a wide range of job openings,
            Saksham supports these PSPs in matching candidates to roles that fit
            them best by leveraging AI.
          </p>
        </div>

        <div className="w-full max-h-[473px] pt-10 px-14">
          <Slider {...settings2}>
            {esrs.map((d, index) => (
              <div
                key={index}
                className="flex items-center justify-center mx-2"
                style={{ width: "200px", height: "200px" }}
              >
                <div className="flex items-center justify-center w-full h-full">
                  <img
                    src={d.logo}
                    alt="Logo"
                    className="max-w-full max-h-full object-contain"
                  />
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>

      {/* ..........Success Stories........... */}
      <div className="mt-1">
        <Stories />
      </div>

      {/* ..........Feedback........... */}
      {/* <Feedback /> */}

      {/*..............News and Articles............. */}
      <div className="mt-2">
        <News />
      </div>
    </>
  );
};

export default Home;
